<template>
  <b-card class="recent-activities mb-0" :class="isDarkMode ? 'dark' : ''">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <p class="recent-activities--title" :class="isDarkMode ? 'dark' : ''">
        Recent Activities
      </p>
      <b-button
        pill
        size="sm"
        variant="info"
        @click="gotoRecentActivitiesPage()"
      >
        See All
      </b-button>
    </div>
    <b-list-group v-if="recentActivitiesData && recentActivitiesData.length">
      <b-list-group-item
        class="d-flex"
        v-for="activity in recentActivitiesData"
        :key="activity.timestamp"
      >
        <p class="h1 mr-3">
          <ActivitiesIcons :activityText="activity.title" :fontScale="0.7" />
        </p>
        <span>
          <span
            class="recent-activities--item-title"
            :class="isDarkMode ? 'dark' : ''"
            >{{ activity.title }}
            <span
              class="recent-activities--item-phone"
              :class="isDarkMode ? 'dark' : ''"
              >{{ prettyPhoneNumber(activity.recipient_number) }}</span
            ></span
          >
          <span
            class="recent-activities--item-sub-title"
            :class="isDarkMode ? 'dark' : ''"
            >{{ formatDate(activity.timestamp, "MMM D, YYYY h:mm a") }}</span
          >
        </span>
      </b-list-group-item>
    </b-list-group>
    <p v-else class="text-center pt-3">No Data Found</p>
  </b-card>
</template>

<script>
import formatter from "../../../mixins/formatter";
import ActivitiesIcons from "../activities/ActivitiesIcons.vue";

export default {
  name: "RecentActivities",
  mixins: [formatter],
  props: {
    recentActivitiesData: Array,
    isDarkMode: Boolean,
  },
  data() {
    return {};
  },
  components: {
    ActivitiesIcons,
  },
  methods: {
    gotoRecentActivitiesPage() {
      this.$router.push({ path: "/admin/recent-activities" }).catch(() => {});
    },
  },
};
</script>


<style lang="scss">
.recent-activities {
  &.dark {
    color: #b2b9bf !important;
  }
  &.card {
    height: 388px;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%), 0 6px 20px 0 rgb(0 0 0 / 12%);
    border-radius: 1rem;
    & .card-body {
      height: 100%;
    }
    & .list-group {
      height: calc(100% - 50px);
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
  &--title {
    font-size: 1.125rem;
    text-align: left;
    color: #333843;
    font-weight: 600;
    margin-bottom: 0;
    display: block;
    &.dark {
      color: #b2b9bf !important;
    }
  }
  &--item-title {
    color: #464646;
    font-weight: 500;
    font-size: 0.875rem;
    display: block;
    &.dark {
      color: #b2b9bf !important;
    }
  }
  &--item-sub-title {
    color: #797979;
    font-weight: 500;
    font-size: 0.625rem;
    display: block;
    &.dark {
      color: #b2b9bf !important;
    }
  }
  &--item-phone {
    color: #a3a3a3;
    font-weight: 500;
    font-size: 0.75rem;
    display: block;
    &.dark {
      color: #b2b9bf !important;
    }
  }
  & .list-group-item {
    border: none;
  }
}
</style>